import { IHttpAPI } from './http.types'
import { HttpRequest } from './http.request'

export class HttpAuthRequest extends HttpRequest implements IHttpAPI {
  constructor() {
    super(process.env.AUTH_URL as string)
  }
}
